import { LevelEditorComponent } from "../../leveleditor.component";
import { PolygonMapComponent } from "./PolygonMapComponent";
import { fabric } from 'fabric';

export class Level extends PolygonMapComponent{
    public override ClassName: string = "Level"
    public override FillColor: string = "#b2b2b2";
    public override StrokeColor: string = "#FFFFFF";
    public override StrokeWidth: number = 4;
    public override ShowLabel: boolean = true;
    public override ShowMeasurementLines: boolean = true;
    public override zIndex: number = 20;
    public override CanDuplicate: boolean = false;

    
    constructor(leveleditorcomponent: LevelEditorComponent, canvas: any, formItem: any, parentFormItem: any, forceClone: boolean = false) {
        super(leveleditorcomponent, canvas, formItem, parentFormItem, forceClone);
        this.AddFabricItem();
    }

    public override Clone(formitem: any){
        return new Level(this.leveleditorcomponent, this.canvas, formitem, this.parentFormItem, true);
    }
}
